import { useEffect, useState } from "react"
import { Grower, GrowersList, GrowerWithoutId, Supplier, SupplierList } from "../../interfaces/interfaces.auth"
import { CardSupplier } from "../cards/CardSupplier"
import { sortGrowersByName, sortSuppliersByName } from "../../helpers/sortContacts"
import { AddButton } from "../ui/AddButton"
import { ModalAddSupplier } from "../modals/ModalAddSupplier"
import { IoAdd, IoSearchOutline } from "react-icons/io5"
import { ButtonCustom } from "../ui/ButtonCustom"
import { CardGrower } from "../cards/CardGrower"
import { ModalAddGrower } from "../modals/ModalAddGrower"
import { ModalConfirmation } from "../ui/ModalConfirmation"
import { ButtonCSV } from "../ui/ButtonCSV"
import { useSaveManyGrowers } from "../../api/useGrower"
import { useDispatch } from "react-redux"
import { startChecking } from "../../store/asyncMethods/authMethods"
import toast from "react-hot-toast"

interface Props {
    growersList: GrowersList
}

export const Growers = ({ growersList }: Props) => {

    const [modalAddGrower, setModalAddGrower] = useState<boolean>(false)
    const { mutate, isLoading } = useSaveManyGrowers()

    const dispatch = useDispatch()

    const [searcher, setSearcher] = useState<string>("")
    const [result, setResult] = useState<Grower[]>([])

    useEffect(() => {
        if (searcher.length > 0) {
            const searching = growersList.growers.filter(grower => (grower.name).toLowerCase().includes(searcher.toLowerCase()))
            setResult(searching)
        } else {
            setResult(growersList.growers || [])
        }
    }, [searcher, growersList])

    useEffect(() => {
        setResult(growersList.growers || [])
    }, [growersList])

// const processNumber = (str:string) => {
//   return str
//     .replace(/^\*/, '')        // Eliminar * inicial
//     .replace(/\.(\d+)\./, '.$1.'); // Eliminar el segundo punto
// };

const processNumber = (str:string) => {
  return str.replace(/^\*/, '').replace(/\.(\d+)\./, '.$1');
};

    const handleCSV = (data: any[]) => {

        const normalizedData: GrowerWithoutId[] = data.filter(item => item.ggn).map(item => {

            // const newLat = Number(item["lat decimal"]?.split(",").join("."))
            // const newLon = Number(item["long decimal"]?.split(",").join("."))
            const newLat = Number(processNumber(item["lat decimal"]?.split(",").join(".")))
            const newLon = Number(processNumber(item["long decimal"]?.split(",").join(".")))

            return {
                name: item["company name"] || "",
                ggn_number: item.ggn || "",
                fields: [
                    {
                        name: "field 1",
                        country: item.country || "",
                        city: item.city || item["type/region"] || "",
                        coords: {
                            lat: !isNaN(newLat) ? newLat : 0,
                            lon: !isNaN(newLon) ? newLon : 0,
                        }
                    }
                ]
            }
        })

        const payload = {
            id: growersList.id,
            model: growersList.model,
            growers: normalizedData
        }

        mutate(payload, {
            onSuccess: () => {
                dispatch(startChecking())
                toast.success("Growers added successfully")
                // closeModal()
            },
        })

    };

    return (
        <>
            {
                modalAddGrower &&
                <ModalAddGrower
                    closeModal={() => setModalAddGrower(false)}
                    target={growersList}
                />
            }

            <section>
                <div className="flex-space-between mb-2">
                    <div className="tw-flex tw-gap-1">

                        <ButtonCustom text="Add Grower" iconBefore={<IoAdd color="white" size={15} />} action={() => setModalAddGrower(true)} />
                        <ButtonCSV handleCSV={handleCSV} />

                    </div>
                    <div className="flex">
                        <IoSearchOutline />

                        <input
                            id="grower-search"
                            className="input-search ml-05"
                            type="text"
                            value={searcher}
                            onChange={(e) => setSearcher(e.target.value)}
                        />
                    </div>
                </div>

                <div>
                    {
                        growersList.growers.length === 0
                            ? <p className="text-center my-1 font-normal bold">No growers</p>
                            :
                            <>
                                {
                                    sortGrowersByName(result).map(grower => (
                                        <CardGrower
                                            key={grower._id}
                                            grower={grower}
                                            target={growersList}
                                        />
                                    ))
                                }
                            </>
                    }
                </div>



            </section>
        </>
    )
}
